function AdmissionBanner() {
  return (
    <div className="admission-banner">
      <h2>Admission Open 2026-27</h2>

      <div>
        <a href="/admission" className="btn">Register Now</a>
        <a href="/contact" className="btn">Contact Us</a>
      </div>
    </div>
  );
}
export default AdmissionBanner;